import React from "react";
import PropTypes from "prop-types";

function PhoneMask({ value, ...props }) {
  if (!value) return null;

  const [one, two, three, four] = value.match(/.{1,3}/g);

  return <div {...props}>{`(${one}) ${two}-${three + four}`}</div>;
}

PhoneMask.propTypes = {
  value: PropTypes.string,
};

export default PhoneMask;
